<script setup lang="ts">
import { computed } from "vue";
import Dragger from "./Dragger.vue";
import ToolOptionsDropdown from "./toolbar/ToolOptionsDropdown.vue";
import { DraggerType } from "@/drawing";
import DraggerMenuState from "@/stores/DraggerMenuState";
import AddLabelBtn from "./options/AddLabelBtn.vue";
import TwoPointModeBtn from "./options/TwoPointModeBtn.vue";
import KeypadToggleBtn from "./options/KeypadToggleBtn.vue";
import DisableToolBtn from "./options/DisableToolBtn.vue";
import Settings from "@/stores/Settings";

/** Ligne, ellipse, rectangle : même panneau (étiquette, placement en 2 points). */
const props = defineProps<{
  shape: "line" | "ellipse" | "rectangle";
}>();

const SHAPES = {
  line: {
    dragger: DraggerType.Line,
    icon: "line-segment",
    tooltip: "straightline",
  },
  ellipse: { dragger: DraggerType.Ellipse, icon: "circle", tooltip: "ellipse" },
  rectangle: {
    dragger: DraggerType.Rectangle,
    icon: "square",
    tooltip: "rectangle",
  },
} as const;

const config = computed(() => SHAPES[props.shape]);
</script>

<template>
  <ToolOptionsDropdown :owners="[config.dragger]">
    <template #tool>
      <Dragger
        :config="{ name: config.dragger }"
        :phosphor-icon="config.icon"
        :tooltip-text="$t(`canvas:tools.${config.tooltip}.tooltip.text`)"
        :tooltip-title="$t(`canvas:tools.${config.tooltip}.tooltip.title`)"
        @click="DraggerMenuState.setActiveDragger({ name: config.dragger })"
      />
    </template>
    <div
      class="btn-group-vertical rounded p-1"
      style="background-color: var(--canvas-bg)"
    >
      <DisableToolBtn v-if="!Settings.onlyStylusOn" />
      <AddLabelBtn />
      <TwoPointModeBtn />
      <KeypadToggleBtn v-if="DraggerMenuState.sequentialPointMode" />
    </div>
  </ToolOptionsDropdown>
</template>
